import { render, staticRenderFns } from "./ContentTop.vue?vue&type=template&id=640e8d8f"
import script from "./ContentTop.vue?vue&type=script&lang=js"
export * from "./ContentTop.vue?vue&type=script&lang=js"
import style0 from "./ContentTop.vue?vue&type=style&index=0&id=640e8d8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports